import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/paysuccess.css";

function PaymentFailed() {
  return (
    <main
      className="confirmation-page confirmation-page--failed"
      id="main-content"
    >
      <div className="confirmation-shell">
        <section
          className="confirmation-card"
          aria-labelledby="payment-failed-title"
        >
          <div
            className="confirmation-card__mark confirmation-card__mark--failed"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24" focusable="false">
              <path d="M6 6l12 12M18 6 6 18" />
            </svg>
          </div>
          <span className="confirmation-eyebrow">Payment incomplete</span>
          <h1 id="payment-failed-title">Your payment was not completed.</h1>
          <p className="confirmation-card__intro">
            No order has been confirmed. You can return to checkout and try
            again, or contact {siteConfig.brandName} if you need assistance.
          </p>
          <div className="confirmation-actions">
            <Link className="confirmation-button" to="/checkout">
              Try payment again
            </Link>
            <Link className="confirmation-link" to="/cartpage">
              Return to cart
            </Link>
            <a
              className="confirmation-link"
              href={`mailto:${siteConfig.contact.email}`}
            >
              {siteConfig.contact.email}
            </a>
          </div>
        </section>
      </div>
    </main>
  );
}

export default PaymentFailed;
